import {VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonData.type";
import useHandleJadrolinijaVehicleSelection
    from "@CheckOrder/features/addons/features/jadrolinija/hooks/useHandleJadrolinijaVehicleSelection";
import React from "react";
import VehicleModel
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleModel/components/VehicleModel";
import VehicleAdditionalLength
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleAdditionalLength/components/VehicleAdditionalLength";
import VehicleAdditionalHeight
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleAdditionalHeight/components/VehicleAdditionalHeight";
import VehicleRegistration
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleRegistration/components/VehicleRegistration";
import VehicleType from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleType/components/VehicleType";
import Grid from "@Containers/components/Grid";
import VehiclePreselectedForReturnTripNotification
    from "@CheckOrder/features/addons/features/jadrolinija/components/VehiclePreselectedForReturnTripNotification";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import Button from "@Generic/buttons/Button";
import Translation from "@Translation/components/Translation";
import checkActiveOptionType from "@CheckOrder/features/addons/features/jadrolinija/functions/checkActiveOptionType";
import useCancelVehicleAddon from "@CheckOrder/features/addons/features/jadrolinija/hooks/useCancelVehicleAddon";

type VehicleTypeSelectProps = {
    vehicles: VehicleAddonResponseType[],
}

function VehicleTypeSelect({vehicles}: VehicleTypeSelectProps) {
    const {
        updateTicketWithAddon,
        setRegistrationNumber,
        registrationNumber,
        showErrors,
        selectOptions,
        activeOption,
        setVehicleType,
        selectedVehicle,
        setVehicle,
        autoSuggestModels,
        additionalHeight,
        setHeight,
        additionalLength,
        setLength,
        isRental,
        toggleRental,
    } = useHandleJadrolinijaVehicleSelection(vehicles)

    const {isReturn} = useAppSelector((state) => (state.checkOrder.ticket))
    const {isBike, isCar} = checkActiveOptionType()

    const {cancelAddon} = useCancelVehicleAddon()

    return (
        <>
            {isReturn && (
                <VehiclePreselectedForReturnTripNotification/>
            )}
            <Grid autofill={isBike(activeOption)}>
                <VehicleType
                    selectOptions={selectOptions}
                    activeOption={activeOption}
                    setVehicleType={setVehicleType}
                />
                {isCar(activeOption) && (
                    <VehicleModel
                        selectedVehicle={selectedVehicle}
                        setVehicle={setVehicle}
                        autoSuggestModels={autoSuggestModels}
                        showErrors={showErrors}
                    />
                )}
                {activeOption.activeGroup.lengthOptions && (
                    <VehicleAdditionalLength
                        activeOption={activeOption}
                        setLength={setLength}
                        additionalLength={additionalLength}
                    />
                )}
                {activeOption.activeGroup.heightOptions && (
                    <VehicleAdditionalHeight
                        activeOption={activeOption}
                        setHeight={setHeight}
                        additionalHeight={additionalHeight}
                    />
                )}
                {!isBike(activeOption) && (
                    <VehicleRegistration
                        isRental={isRental}
                        registrationNumber={registrationNumber}
                        setRegistrationNumber={setRegistrationNumber}
                        toggleRental={toggleRental}
                        showErrors={showErrors}
                    />
                )}
            </Grid>
            <div className="ticket-addons__controls">
                <Button
                    onClick={updateTicketWithAddon}
                    className="primary"
                    additionalClasses="ticket-addons__confirm"
                >
                    <Translation
                        translationKey="check_order.addons.JADL.vehicle.confirm"
                        translationVariables={{vehicle: activeOption.label}}
                    />
                </Button>
                <button
                    type="button"
                    onClick={cancelAddon}
                    className="ticket-addons__cancel"
                >
                    <Translation
                        translationKey="check_order.addons.JADL.vehicle.cancel"
                    />
                </button>
            </div>
        </>
    );
}

export default VehicleTypeSelect;